"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductDashboardProductUnitOfMeasure = void 0;
class ProductDashboardProductUnitOfMeasure {
}
exports.ProductDashboardProductUnitOfMeasure = ProductDashboardProductUnitOfMeasure;
//# sourceMappingURL=product-dashboard-product-um.response.js.map